import { makeLink, makeUserContentLink, makeEmbedCode } from '../../utils/linkbuilder';
import EmbedPane from '../../components/embedpane';

const EMBED_MSG:string="Embed code";

interface EmbedWrapperProps{
	pageSelected:string,
	usermail:string,
	contentSelected:string[]
	embedTestClick:() => void,
	testEmbed:boolean
}

export const EmbedWrapper=function(props:EmbedWrapperProps){
	if(props.pageSelected==='')return null;
	if(props.contentSelected[1]==='user'&&props.usermail==='')return null;

	let myLink=makeLink(props.pageSelected,props.contentSelected);
	if(props.contentSelected[1]==='user'){
		myLink=makeUserContentLink(props.pageSelected,props.usermail,props.contentSelected[0]);
	}
	
	let myEmbedCode=makeEmbedCode(myLink);
	return(
		<div>
			<h3>{EMBED_MSG}</h3>
			<EmbedPane embedCode={myEmbedCode} />
			<hr />
			<p>Copy the above code into your webpage or blog.</p>
			<p>Click below to test here on this page.</p>
			<button onClick={()=>{props.embedTestClick();}} className='teachers-button teachers-button-light'>Test</button>
			<EmbedTest testEmbed={props.testEmbed} embedCode={myEmbedCode} />
		</div>
	)
}

const EmbedTest=function(props:{testEmbed:boolean, embedCode:string}){
	if(props.testEmbed===false)return null;
	return(
	  <div id='teachers-testembed'>
		 <div dangerouslySetInnerHTML={prepEmbedCode(props.embedCode)} />
	  </div>
	);
}

const prepEmbedCode=function(embedCode:string) {
  return {__html: embedCode};
};
